// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","left":"Hero_left__aDgJ6","right":"Hero_right__BRKZN"};